// extracted by mini-css-extract-plugin
module.exports = {"header":"Performance_header__3hozm","periodSelector":"Performance_periodSelector__2DyKf","title":"Performance_title__34_J-"};